/**
 * info-row.js
 */

import React from 'react';
import Icon from 'components/icon';
import { Typography } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  title: {
    // whiteSpace: 'nowrap',
    fontWeight: 500,
    marginRight: theme.spacing(0.5),
  },
  icon: {
    paddingRight: theme.spacing(0.5),
    color: theme.palette.grey.colors[5],
    height: '1.2em',
    width: '1.2em',
    [theme.breakpoints.down('sm')]: {
      height: '0.9em',
      width: '0.9em',
    },
  },
}));

export default function InfoRow(props) {
  const { title, text, iconName, dataTestId, showEmptyDefault = false } = props;
  const classes = useStyles();

  const textToDisplay = (text !== null && text !== undefined && text !== '')
    ? text.toString() // convert to string to avoid 0 being falsy
    : showEmptyDefault 
      ? '\u2014'
      : '';

  return (
    <div
      style={{ display: 'flex', alignItems: 'flex-start', ...props.style }}
      className={props.className || ''}
    >
      {iconName &&
      <Icon type={iconName} className={classes.icon}/>}
      <Typography variant='body2'>
        <span className={classes.title}>
          {title}{`${textToDisplay}` && ':'}
        </span>
        <span data-testid={dataTestId ?? `info-row-${title && title.toLowerCase().replaceAll(' ', '-')}`}>
          {textToDisplay}
        </span>
      </Typography>
    </div>
  )
}